<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Recipient Death EMR-OATS Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-3 fieldName">
            In EMR
          </div>
          <div class="col-2 fieldName">
            In OATS
          </div>
        </div>
        <div class="row" >
          <div class="col-3">
            <ADSTextInput
              v-model="causeOfDeathCategory"
              disabled
              label="Cause of Death Category"
              :class="{ highlightField: isDifferent(causeOfDeathCategory, causeOfDeathCategoryOATS) }"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="causeOfDeathCategoryOATS"
              disabled
              label="Cause of Death Category"
              class="causeOfDeathCategory" 
            />
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="causeOfDeathType"
              disabled
              label="Cause of Death Type"
              :class="{ highlightField: isDifferent(causeOfDeathType, causeOfDeathTypeOATS) }"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="causeOfDeathTypeOATS"
              disabled
              label="Cause of Death Type"
            />
          </div>
        </div>
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="causeOfDeathTypeOther"
              disabled
              label="Cause of Death Type Other"
              :class="{ highlightField: isDifferent(causeOfDeathTypeOther, causeOfDeathTypeOtherOATS) }"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="causeOfDeathTypeOtherOATS"
              disabled
              label="Cause of Death Type Other"
            />
          </div>
        </div>
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="deathDate"
              disabled
              label="Death Date"
              :class="{ highlightField: isDifferent(deathDate, deathDateOATS) }"
            />
          </div>
  
          <div class="col-2">
            <ADSTextInput
              v-model="deathDateOATS"
              disabled
              label="Death Date"
            />
          </div>
        </div>
  
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="deathDateEstimated"
              disabled
              label="Death Date Estimated"
              :class="{ highlightField: isDifferent(deathDateEstimated, deathDateEstimatedOATS) }"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="deathDateEstimatedOATS"
              disabled
              label="Death Date Estimated"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="comments"
              disabled
              label="Comments"
              :class="{ highlightField: isDifferent(comments, commentsOATS) }"
            />
          </div>
          <div class="col-2">
            <ADSTextInput
              v-model="commentsOATS"
              disabled
              label="Comments"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>
  
  <script>
  import _ from 'lodash';
  // eslint-disable-next-line no-unused-vars
  import { ORGAN_LIST } from '@/constants';
  
  export default {
    name: "DonorAcceptabilitySectionDetailsEMROATS",
    props: {
      patient: {
        type: Object,
        default: null,
      },
      patientBundle: {
        type: Object,
        default: null,
      },
      patientBundleOATS: {
        type: Object,
        default: null,
      },
      organ: {
        type: String,
        default: null,
      }
    },
    data() {
      return {
        causeOfDeathCategory: this.getCauseDeathCategory( this.patientBundle ),
        causeOfDeathCategoryOATS: this.getCauseDeathCategoryOATS( this.patientBundleOATS ),
        causeOfDeathType: this.getCauseDeathType( this.patientBundle ),
        causeOfDeathTypeOATS: this.getCauseDeathTypeOATS( this.patientBundleOATS ),
        causeOfDeathTypeOther: this.getCauseDeathTypeOther( this.patientBundle ),
        causeOfDeathTypeOtherOATS: this.getCauseDeathTypeOtherOATS( this.patientBundleOATS ),
        deathDate: this.getDeathDate( this.patientBundle ),
        deathDateOATS: this.getDeathDateOATS( this.patientBundleOATS ),
        deathDateEstimated: this.getDeathDateEstimated( this.patientBundle ),
        deathDateEstimatedOATS: this.getDeathDateEstimatedOATS( this.patientBundleOATS ),
        comments: this.getComments( this.patientBundle ),
        commentsOATS: this.getCommentsOATS( this.patientBundleOATS ),
      };
      },
     mounted() {
      
      },
    methods: {
      combineProps() {
        return `${this.patient}`;
      },
      isDifferent( a, b ) {
        return String( a ?? '' ).trim().toLowerCase() !== String( b ?? '' ).trim().toLowerCase();
    },
    isDifferentAcceptance( a, b ) {
        if( a === 'Yes' && b === 'Decline' ) {
          return true;
        }
        if( a === 'Decline' && b === 'Yes' ) {
          return true;
        }
        if( a === 'No' && b === 'Accept' ) {
          return true;
        }
        if( a === 'Accept' && b === 'No' ) {
          return true;
        }
        if( a !== null && ( b === null || b === '' ) ) {
          return true;
        }
        if( ( a === null || a === '' ) && b !== null ) {
          return true;
        }
        return false;
    },
    getEpisodePhase( patientBundle ) {
        if ( !patientBundle?.entries ) {
          return;
        }
        let episodeOfCares = patientBundle.entries.filter( ( n ) => (
          _.get( n[0], 'resource.resourceType' ) === 'EpisodeOfCare' 
        ) );
        if ( !( episodeOfCares?.[0]?.[0] ) ) {
          return;
        }
        const episodeOfCare = episodeOfCares[0].filter( ( n ) => ( _.get( n, 'resource.id' ) === patientBundle.episode_id ) );
        if ( !( episodeOfCare ) ) {
          return;
        }
        const extensions = episodeOfCare?.[ 0 ]?.resource?.extension;
        if ( !extensions ) {
          return;
        }
        for ( const item of extensions ) {
          if ( item.url?.includes( 'transplant-phase-status' ) && item.extension?.length ) {
            const phaseExt = item.extension.filter( ( ext ) => ext.url === 'phase' );
            if ( phaseExt?.[0] ) {
              return _.get( phaseExt[0], 'valueCodeableConcept.coding[0].code' );
            }
          }
        }
      },
      getSmartdataComponentValue( patientBundle, observationCode, valuePath = 'valueString' ) {
        const entries = patientBundle?.entries;
        if( !entries?.length ) {
          return null;
        }
        const smartdataGroups = entries.filter( ( n ) =>
          _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
          _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
        );
        const group = smartdataGroups[0];
        if( !group ) {
          return null;
        }
        const match = group.filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === observationCode && 
        _.get( n, 'resource.focus[0].reference' )?.includes( patientBundle.episode_id ) ) );
        if( !match[0] ) {
          return null;
        }
        const raw = _.get( match[0], `resource.component[0].${valuePath}` );
        if( raw === null || raw === undefined ) {
          return null;
        }
        return String( raw );
      },
      getCauseDeathCategory( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let causeOfDeathCategory = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#390' ) ) ;
      if( causeOfDeathCategory && causeOfDeathCategory[ 0 ] ) {
        return _.get( causeOfDeathCategory[ 0 ], 'resource.component[0].valueString' ); 
      } 
      }
    },
    getCauseDeathCategoryOATS( patientBundleOATS ) {
      const labelByCode = {
        ACC: 'ACCIDENT',
        CAR: 'CARDIAC',
        GAS: 'GASTRO-INTESTINAL DISORDER',
        INF: 'INFECTION',
        LIV: 'LIVER DISEASE',
        MAL: 'MALIGNANCY',
        MIS: 'MISCELLANEOUS',
        PUL: 'PULMONARY DISEASE',
        REJ: 'REJECTION',
        REN: 'RENAL DISEASE',
        SOC: 'SOCIAL',
        VAS: 'VASCULAR',
        OTH: 'OTHER',
        UNK: 'UNKNOWN',
      };
      const code = patientBundleOATS?.death?.cause_category_code;
      return labelByCode[ code ] ?? code;
    },
    getCauseDeathType( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let causeOfDeathCategory = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#391' ) ) ;
      if( causeOfDeathCategory && causeOfDeathCategory[ 0 ] ) {
        return _.get( causeOfDeathCategory[ 0 ], 'resource.component[0].valueString' ); 
      } 
      }
    },
    getCauseDeathTypeOATS( patientBundleOATS ) {
      const labelByCode = {
        81: 'ACCIDENT RELATED TO TREATMENT',
        178: 'ACCIDENT UNRELATED TO TREATMENT',
        11: 'MYOCARDIAL ISCHAEMIA AND INFARCTION',
        12: 'HYPERKALAEMIA',
        13: 'HAEMORRHAGIC PERICARDITIS',
        14: 'CARDIAC FAILURE - OTHER CAUSES',
        15: 'CARDIAC ARREST, CAUSE UNKNOWN',
        16: 'HYPERTENSIVE CARDIAC FAILURE',
        18: 'FLUID OVERLOAD',
        30: 'RIGHT VENTRICULAR FAILURE',
        88: 'CARDIOMYOPATHY',
        112: 'CORONARY ARTERY DISEASE',
        117: 'CONGESTIVE HEART FAILURE',
        118: 'LEFT VENTRICULAR FAILURE',
        120: 'CHRONIC HEART FAILURE',
        128: 'CVA',
        130: 'MYOCARDIAL INFARCTION',
        131: 'PRIMARY NON-FUNCTION',
        175: 'MYOCARDIAL ISCHAEMIA AND/OR INFARCTION',
        29: 'MESENTERIC INFARCTION',
        62: 'PANCREATITIS',
        101: 'SMALL AND/OR LARGE BOWEL INFARCTION',
        188: 'GASTRO-INTESTINAL HAEMORRHAGE',
        0: 'CAUSE OF DEATH UNCERTAIN / NOT DETERMINED',
        31: 'INFECTION - BACTERIAL',
        32: 'PULMONARY INFECTION (VIRAL)',
        33: 'PULMONARY INFECTION (FUNGAL)',
        34: 'INFECTIONS ELSEWHERE (EXCEPT VIRAL HEPATITIS SEE 41)',
        35: 'SEPTICAEMIA',
        38: 'GENERALIZED VIRAL INFECTION',
        39: 'PERITONITIS',
        48: 'CYTOMEGALOVIRUS',
        100: 'SEPSIS',
        111: 'CRYPTOCOCCUS MENINGITIS',
        114: 'MENINGITIS',
        139: 'ASPERGILLUS INFECTION',
        160: 'EPSTEIN-BARR VIRUS',
        161: 'TUBERCULOSIS',
        170: 'INFECTION - VIRAL',
        171: 'INFECTION - FUNGAL',
        182: 'BRAIN ABSCESS',
        5: 'HEPATIC ARTERY BLEED',
        6: 'PORTAL VEIN THROMBOSIS',
        7: 'BILE LEAK',
        8: 'HEPATIC ARTERY THROMBOSIS',
        9: 'HEPATIC ARTERY ANEURYSM',
        20: 'HEPATITIS RECURRENCE',
        40: 'CIRRHOSIS - RECURRENCE',
        41: 'HEPATITIS - B',
        42: 'HEPATITIS - OTHER VIRAL',
        43: 'DRUG TOXICITY',
        44: 'CIRRHOSIS - NOT VIRAL',
        45: 'CYSTIC LIVER DISEASE',
        46: 'UNKNOWN CAUSE OF LIVER FAILURE',
        69: 'RECURRENT HEPATITIS B',
        72: 'RECURRENT CHOLANGIOCARCINOMA',
        102: 'MYCOTIC ANEURYSM OF HEPATIC ARTERY',
        115: 'BILE DUCT STRICTURE',
        144: 'HEPATITIS - C',
        173: 'HEPATITIS - RECURRENCE',
        181: 'PORTAL HYPERTENSION',
        47: 'LYMPHOMA',
        66: 'MALIGNANT DISEASE POSSIBLY INDUCED BY IMMUNOSUPPRESSIVE THERAPY',
        67: 'MALIGNANT DISEASE EXCEPT THOSE OF 66',
        83: 'KAPOSI\'S SARCOMA',
        85: 'MALIGNANT DISEASE NOT ELESWHERE CLASSIFIED',
        86: 'SQUAMOUS CELL CARCINOMA',
        90: 'METASTATIC CARCINOMA - ABDOMINAL CAVITY',
        91: 'METASTATIC CARCINOMA - BRAIN',
        92: 'METASTATIC CARCINOMA - BREAST',
        93: 'METASTATIC CARCINOMA - LIVER',
        94: 'METASTATIC CARCINOMA - LUNG',
        95: 'METASTATIC CARCINOMA - THYROID',
        96: 'METASTATIC CARCINOMA - UTERUS',
        119: 'METASTATIC CARCINOMA - BOWEL',
        121: 'ACUTE LYMPHOCYTIC LEUKEMIA',
        132: 'METASTATIC CARCINOMA - PAROTID GLAND',
        136: 'PANCREATIC CANCER',
        137: 'METASTATIC MELANOMA',
        147: 'METASTATIC CARCINOMA - RECTUM',
        149: 'CERVICAL CANCER',
        150: 'HEPATOCELLULAR CARCINOMA',
        151: 'METASTATIC CARCINOMA',
        152: 'PROSTATE CANCER',
        155: 'RENAL CELL CARCINOMA',
        156: 'LUNG CANCER',
        185: 'CHOLANGIOCARCINOMA',
        186: 'MALIGNANT DISEASE - OTHER',
        10: 'BRAIN DEATH',
        17: 'PERIPHERAL POLYNEURITIS',
        19: 'DRUG TOXICITY - CYCLOSPORINE',
        36: 'IMMUNOLOGICAL',
        37: 'ABO INCOMPATABILITY',
        63: 'BONE MARROW DEPRESSION',
        68: 'MULTIPLE ORGAN SYSTEM FAILURE',
        80: 'MYCOMYOSIS',
        87: 'MVA',
        97: 'DIABETES',
        98: 'DIED BEFORE TRANSPLANT',
        99: 'OTHER IDENTIFIED CAUSE OF DEATH',
        106: 'PRIMARY NON-FUNCTION',
        107: 'SICKLE CELL ANEMIA',
        108: 'INTRAOPERATIVE DEATH - CAUSE UNKNOWN',
        109: 'LOU GEHRIG\'S DISEASE',
        110: 'INTRAOPERATIVE BLEED',
        134: 'MULTIPLE ORGAN FAILURE DUE TO INFECTION',
        148: 'ANOXIA',
        165: 'DRUG NEUROTOXICITY',
        176: 'MULTI-ORGAN FAILURE',
        179: 'UNKNOWN',
        183: 'SEIZURES',
        184: 'FAILURE OF TRANSPLANT',
        192: 'IMMUNOLOGICAL - DEVELOPED ANTIBODIES',
        199: 'PERITONEAL SCLEROSIS',
        201: 'INTRA-ABDOMINAL BLEED',
        202: 'SURGICAL COMPLICATIONS',
        135: 'RENAL FAILURE',
        143: 'INFARCTED KIDNEY',
        21: 'PULMONARY EMBOLUS',
        49: 'PNEUMONIA',
        50: 'BRONCHIOLITIS OBLITERANS ORGANIZING PNEUMONIA (BOOP)',
        54: 'ALPHA ONE ANTITRYPSIN DEFICIENCY',
        55: 'EMPHYSEMA',
        56: 'BRONCHIOLITIS OBLITERANS',
        57: 'CHRONIC OBSTRUCTIVE PULMONARY DISEASE (COPD)',
        58: 'PLEURAL EFFUSION',
        59: 'PNEUMOTHORAX',
        60: 'PULMONARY EDEMA',
        64: 'PNEUMOCYSTIS CARINII PNEUMONIA',
        73: 'HEMOPTYSIS',
        74: 'CYTOMEGALOVIRUS PNEUMONIA',
        75: 'ACUTE RESPIRATORY DISTRESS SYNDROME (ARDS)',
        76: 'PULMONARY HYPERTENSION',
        104: 'PULMONARY FIBROSIS',
        113: 'BRONCHOPNEUMONIA',
        116: 'DIFFUSE ALVEOLAR DAMAGE',
        122: 'RESPIRATORY FAILURE AND PULMONARY EMBOLI',
        123: 'RESPIRATORY FAILURE SECONDARY TO COPD',
        124: 'RESPIRATORY FAILURE SECONDARY TO CYSTIC FIBROSIS EXACERBATION',
        125: 'RESPIRATORY FAILURE SECONDARY TO END STAGE PULMONARY FIBROSIS',
        126: 'RESPIRATORY FAILURE SECONDARY TO INTERSTITIAL PULMONARY FIBROSIS',
        127: 'LEFT PULMONARY ARTERY OCCLUSIONS',
        133: 'PSEUDOMONAS PNEUMONIA',
        140: 'AIRWAY DEHISCENCE',
        145: 'PSEUDOMONAS CEPACIA',
        146: 'RESPIRATORY FAILURE',
        168: 'PULMONARY - OTHER',
        172: 'PNEUMOCYSTIC PNEUMONIA',
        77: 'HYPERACUTE REJECTION',
        78: 'ACUTE REJECTION',
        79: 'CHRONIC REJECTION',
        141: 'VASCULAR REJECTION',
        190: 'GRAFT REJECTION',
        166: 'RENAL FAILURE - ACUTE',
        167: 'RENAL FAILURE - CHRONIC',
        180: 'URAEMIA CAUSED BY GRAFT FAILURE',
        191: 'RENAL FAILURE - OTHER',
        51: 'TREATMENT CEASED - PATIENT REFUSAL',
        52: 'SUICIDE',
        53: 'TREATMENT CEASED - OTHER',
        142: 'MURDER',
        162: 'DRUG ABUSE (EXCLUDES ALCOHOL ABUSE)',
        163: 'ALCOHOL ABUSE',
        2: 'INTRA-CEREBRAL BLEED',
        3: 'CEREBRAL EDEMA',
        22: 'CEREBRO-VASCULAR ACCIDENT',
        25: 'HAEMORRHAGE FROM VASCULAR ACCESS OR DIALYSIS CIRCUIT',
        26: 'HAEMORRHAGE FROM RUPTURED VASCULAR ANEURYSM',
        28: 'HAEMORRHAGE - OTHER',
        89: 'PERIPHERAL VASCULAR DISEASE',
        105: 'BRAIN ANEURYSM',
        138: 'CENTRAL PONTINE MYELINOLYSIS',
        153: 'SUBDURAL HEMATOMA',
        164: 'THROMBOCYTOPENIA',
        177: 'CEREBROVASCULAR ACCIDENT',
      };
      const code = patientBundleOATS?.death?.cause_type_code;
      return labelByCode[ code ] ?? code;
    },
    getCauseDeathTypeOther( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let causeOfDeathCategory = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#392' ) ) ;
      if( causeOfDeathCategory && causeOfDeathCategory[ 0 ] ) {
        return _.get( causeOfDeathCategory[ 0 ], 'resource.component[0].valueString' ); 
      } 
      }
    },
    getCauseDeathTypeOtherOATS( patientBundleOATS ) {
      return patientBundleOATS?.death?.cause_type_other;
    },
    getDeathDate( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let deathDate = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#388' ) ) ;
      if( deathDate && deathDate[ 0 ] ) {
        return _.get( deathDate[ 0 ], 'resource.component[0].valueDateTime' ); 
      } 
      }
    },
    getDeathDateOATS( patientBundleOATS ) {
      return patientBundleOATS?.death?.death_date;
    },
    getDeathDateEstimated( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let deathDateEstimated = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#389' ) ) ;
      if( deathDateEstimated && deathDateEstimated[ 0 ] ) {
        return _.get( deathDateEstimated[ 0 ], 'resource.component[0].valueBoolean', '' ).toString();
      } 
      }
    },
    getDeathDateEstimatedOATS( patientBundleOATS ) {
      return patientBundleOATS?.death?.estimated_death_date;
    },
    getComments( patientBundle ) {
      let observation = patientBundle.entries.filter( ( n ) => ( _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata' ) );
      if( observation && observation[ 0 ] ) {
        let comments = observation[ 0 ].filter( ( n ) => ( _.get( n, 'resource.code.coding[0].code' ) === 'TXP#393' ) ) ;
      if( comments && comments[ 0 ] ) {
        return _.get( comments[ 0 ], 'resource.component[0].valueString', '' );
      } 
      }
    },
    getCommentsOATS( patientBundleOATS ) {
      return patientBundleOATS?.death?.comments;
    },
  },
  };
  </script>
  
  <style scoped>
  
  /* .card {
    height: 350px;
  } */
  
  .sectionHeading {
    background-color: rgb(59, 53, 53);
    color: white;
    padding-left: 5px;
  }
  
  .page-content .summary-card .card-header .summary-name {
    padding-left: 35px;
    padding-top: 4px;
    font-weight: 300;
  }
  
  .sections {
    font-size: 15px;
    height: 980px;
    width: 1400px;
    /* overflow: scroll; */
    padding-left: 10px;
    padding-top: 5px;
  }
  
  .inputDisplay {
  border-style: solid;
  background-color: #F2F2F2;
  }
  
  .inputDisplayPreferredDonorType {
    border-style: solid;
    width: 300px;
    background-color: #F2F2F2;
  }
  
  .fieldName {
    font-weight: 700;
    font-size: 0.875rem;
    /* padding-top: 5.5px; */
    /* padding-bottom: 2.5px; */
    /* padding-right: 15px; */
    padding-inline-start: 2%;
  }
  
  :deep(.afflo-ds-form-control) {
    width: max-content;
  }
  
  :deep(label) {
    width: max-content;
  }
  
  :deep(.preferredDonorType .afflo-ds-form-control) {
    width: 300px;
  }
  
  :deep(.comments .afflo-ds-form-control) {
    width: 300px;
  }
  
  .highlightField :deep(.afflo-ds-form-control) {
    border: 2px solid red;
  }
  
  </style>
  